import React, { useCallback, useRef } from 'react';
import { useTwilioAppState } from '../../state';
import VideoTrack from '../VideoTrack';
import useMediaStreamTrack from '../../hooks/useMediaStreamTrack';
import useVideoContext from '../../hooks/useVideoContext';
import useLocalVideoToggle from '../../hooks/useLocalVideoToggle';
import useDevices from '../../hooks/useDevices';
import Select from '../../../../common/input/select';
import { Logger } from '../../utils';

export default function VideoInputList() {
    const { videoInputDevices } = useDevices();
    const [isVideoEnabled, toggleVideoEnabled] = useLocalVideoToggle();
    const lastClickTimeRef = useRef(0);   
    const { localTracks } = useVideoContext();
    const localVideoTrack = localTracks.find(track => track.kind === 'video');
    const mediaStreamTrack = useMediaStreamTrack(localVideoTrack);
    const localVideoInputDeviceId = mediaStreamTrack && mediaStreamTrack.getSettings() && mediaStreamTrack.getSettings().deviceId ? mediaStreamTrack.getSettings().deviceId : null;
    const renderedOptions = videoInputDevices.map(device => <option value={device.deviceId} key={device.deviceId}>{device.label}</option>);
    const { settings } = useTwilioAppState();
    let videoConstraints = null;
    videoConstraints = settings.videoConstraints ? settings.videoConstraints : null;
    videoConstraints = settings.video ? settings.video : videoConstraints;

    const DEFAULT_VIDEO_CONSTRAINTS = {
        width: videoConstraints && videoConstraints.width ? videoConstraints.width : 1280,
        height: videoConstraints && videoConstraints.height ? videoConstraints.height : 720,
        frameRate: videoConstraints && videoConstraints.frameRate ? videoConstraints.frameRate : 24
    };

    function replaceTrack(newDeviceId) {
        if (localVideoTrack) {
            localVideoTrack.restart({ ...(DEFAULT_VIDEO_CONSTRAINTS), deviceId: { exact: newDeviceId } });
            Logger(`UI.Twilio.Room.VideoInputDevices.OnChange`, new Date(), { newDeviceId: newDeviceId });
        }
    }

    const toggleVideo = useCallback(() => {       
        Logger(`UI.Twilio.Settings.Camera.${isVideoEnabled ? "Mute" : "Unmute"}.Clicked`, new Date());        
        if (Date.now() - lastClickTimeRef.current > 500) {
            lastClickTimeRef.current = Date.now();
            toggleVideoEnabled();
        }
    }, [toggleVideoEnabled]);

    return (
        <div className="row">
            <div className="col-12 form-group">
                <label className="label">Camera</label>
                {localVideoTrack && mediaStreamTrack ? (videoInputDevices.length > 1 ?
                    <Select onChange={e => replaceTrack(e.target.value)} value={localVideoInputDeviceId || ''} renderedOptions={renderedOptions} disableEmptyOption /> :
                    videoInputDevices.length === 1 ? <label>{localVideoTrack && localVideoTrack.mediaStreamTrack && localVideoTrack.mediaStreamTrack.label || 'No Local Video'}</label> : null
                ) : videoInputDevices.length >= 1 && <label>{videoInputDevices[0].label || 'No Local Video'}</label>
                }
                {/*videoInputDevices.length > 1 ?
                    <Select onChange={e => replaceTrack(e.target.value)} value={localVideoInputDeviceId || ''} renderedOptions={renderedOptions} disableEmptyOption/>
                    : <label>{localVideoTrack && localVideoTrack.mediaStreamTrack && localVideoTrack.mediaStreamTrack.label || 'No Local Video'}</label>
                */}
            </div>
            <div className="col-12">
                <div className="devices-video">
                    {localVideoTrack ? <React.Fragment>
                        <div className="icon-line-camera" onClick={toggleVideo} /> <VideoTrack isLocal track={localVideoTrack} />
                        </React.Fragment>
                        : <React.Fragment>
                            <div className="icon-line-camera-off" onClick={toggleVideo} /> <div className="video-disabled"><p>Camera not enabled</p></div>
                        </React.Fragment>}
                </div>
            </div>
        </div>
    );
}
